/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_CommissionInputs */

const cs_enum_commission = /** @type {(inputs: Enum_CommissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provize`)
};

const en_enum_commission = /** @type {(inputs: Enum_CommissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commission`)
};

/**
* | output |
* | --- |
* | "Commission" |
*
* @param {Enum_CommissionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_commission = /** @type {((inputs?: Enum_CommissionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_CommissionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_commission(inputs)
	return cs_enum_commission(inputs)
});